Vue.component('home', {
    props: ['role', 'user', 'teams', 'currentTeam'],

    /**
     * Load mixins for the component.
     */
    mixins: [require('../../../spark/resources/assets/js/mixins/tab-state')],

    created() {
        /*Bus.$on('sparkHashChanged', function (hash, parameters) {
            mixpanel.track("Loaded a Page", {
                page: hash
            });
        });*/
    },

    /**
     * The component's data.
     */
    data() {
        return {
        };
    },

    /**
     * Prepare the component.
     */
    mounted() {
        //this.usePushStateForTabs('.spark-settings-tabs');
        /*mixpanel.identify(this.user.email);
        mixpanel.people.set({
            "$email": this.user.email,
            "$created": this.user.created_at,
            "$last_login": new Date(),
            "id": this.user.id,
            "name": this.user.name,
            "stripe_id": this.user.stripe_id,
            "trial_ends_at": this.user.trial_ends_at,
            "phone": this.user.phone,
            "current_team_id": this.user.current_team_id
        });*/
    }
});
